document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.shopify-section--header');
    if (!header) return;
    const desktopMenuTrigger = header.querySelectorAll('[data-cust-menu-drawer-trigger]');
    let menuCloseTimeout;
    const isMobile = window.innerWidth <= 999;

    desktopMenuTrigger.forEach(desktopTrigger => {
        const desktopMenuDrawerID = desktopTrigger.dataset.containCustMenuDrawerTriggerId;
        const desktopMenuDrawer = header.querySelector(`[data-contain-cust-menu-drawer-id="${desktopMenuDrawerID}"]`);
        if (!desktopMenuDrawer) return;
        const desktopMenuDrawerPanel = desktopMenuDrawer.querySelector('.custom-desktop-menu__drawer-panel');
        const desktopMenuDrawerOverlay = desktopMenuDrawer.querySelector('.custom-desktop-menu__drawer-overlay');
        const desktopMenuDrawerAfter = desktopMenuDrawer.querySelector('.custom-desktop-menu__drawer-after');

        // Desktop menu drawer trigger logic
        desktopTrigger.addEventListener('mouseenter', function() {
            clearTimeout(menuCloseTimeout);
            header.querySelectorAll('[data-contain-cust-menu-drawer-id]').forEach(drawer => {
                drawer.removeAttribute('open');
            });
            desktopMenuDrawer.setAttribute('open', '');
        });

        desktopMenuDrawer.addEventListener('mouseenter', function(e) {
            clearTimeout(menuCloseTimeout);
            desktopMenuDrawer.setAttribute('open', '');
        });

        desktopMenuDrawer.addEventListener('mouseleave', function() {
            menuCloseTimeout = setTimeout(() => {
                desktopMenuDrawer.removeAttribute('open');
            }, 300);
        });

        // if (desktopMenuDrawerPanel) {
        //     desktopMenuDrawerPanel.addEventListener('mouseleave', function () {
        //         menuCloseTimeout = setTimeout(() => {
        //             desktopMenuDrawer.removeAttribute('open');
        //         }, 300);
        //     });
        // }

        if (desktopMenuDrawerAfter) {
            desktopMenuDrawerAfter.addEventListener('mouseenter', function() {
                clearTimeout(menuCloseTimeout);
                desktopMenuDrawer.removeAttribute('open');
            });
        }

        if (desktopMenuDrawerOverlay) {
            desktopMenuDrawerOverlay.addEventListener('mouseenter', function () {
                menuCloseTimeout = setTimeout(() => {
                    desktopMenuDrawer.removeAttribute('open');
                }, 300);
            });
        }

    });

    // Desktop & mobile third menu trigger logic
    const thirdMenuTrigger = header.querySelectorAll('[data-contain-third-menu-trigger]');
    const allThirdMenus = header.querySelectorAll('[data-contain-third-menu-id]');

    thirdMenuTrigger.forEach(thirdTrigger => {
        const thirdMenuID = thirdTrigger.dataset.containThirdMenuTriggerId;
        let thirdMenu = header.querySelector(`[data-contain-third-menu-id="${thirdMenuID}"]`);
        if (!thirdMenu) return;

        if (isMobile) {
            thirdMenu = header.querySelector(`.custom-mobile-menu__third-list[data-contain-third-menu-id="${thirdMenuID}"]`);

            thirdTrigger.addEventListener('click', function() {
                thirdMenuTrigger.forEach(trigger => trigger.classList.remove('active'));
                allThirdMenus.forEach(menu => menu.classList.remove('active'));
                thirdMenu.classList.toggle('active');
                thirdTrigger.classList.toggle('active');
            });
        } else {
            thirdTrigger.addEventListener('mouseenter', function() {
                clearTimeout(menuCloseTimeout);
                allThirdMenus.forEach(menu => menu.classList.remove('active'));
                thirdMenuTrigger.forEach(trigger => trigger.classList.remove('active'));
                thirdMenu.classList.add('active');
                thirdTrigger.classList.add('active');
            });

            thirdMenu.addEventListener('mouseleave', function() {
                menuCloseTimeout = setTimeout(() => {
                    thirdMenu.classList.remove('active');
                    thirdTrigger.classList.remove('active');
                }, 300);
            });
        }

    });

    // Desktop: observer for drawer open attribute changes
    const allDesktopMenuDrawers = header.querySelectorAll('[data-contain-cust-menu-drawer-id]');
    allDesktopMenuDrawers.forEach(drawer => {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    if (!drawer.hasAttribute('open')) {
                        const thirdMenusInDrawer = drawer.querySelectorAll('[data-contain-third-menu-id]');
                        thirdMenusInDrawer.forEach(menu => menu.classList.remove('active'));
                    }
                }
            });
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    });

    // Mobile: observer for details elements (parent of thirdTrigger/thirdMenu) open attribute changes
    if (isMobile) {
        thirdMenuTrigger.forEach(thirdTrigger => {
            const parentDetails = thirdTrigger.closest('details');
            if (!parentDetails) return;

            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                        if (!parentDetails.hasAttribute('open')) {
                            thirdTrigger.classList.remove('active');
                            const thirdMenuID = thirdTrigger.dataset.containThirdMenuTriggerId;
                            const thirdMenu = header.querySelector(`.custom-mobile-menu__third-list[data-contain-third-menu-id="${thirdMenuID}"]`);
                            if (thirdMenu) {
                                thirdMenu.classList.remove('active');
                            }
                        }
                    }
                });
            });
            observer.observe(parentDetails, { attributes: true, attributeFilter: ['open'] });
        });
    }

    // Get header width
    const logo = header.querySelector('.header__logo');
    const primaryNav = header.querySelector('.header__primary-nav');
    if (!logo || !primaryNav) return;

    function updateHeaderWidthVar() {
    const logoRect = logo.getBoundingClientRect();
    const primaryRect = primaryNav.getBoundingClientRect();

    const totalWidth =
        primaryRect.right - logoRect.left;

    header.style.setProperty(
        '--header-left-width',
        `${totalWidth}px`
    );
    }

    updateHeaderWidthVar();

    window.addEventListener('resize', updateHeaderWidthVar);
    
});
